import Invoice6Container from "../../../../../Components/Applications/Ecommerce/Invoice/Invoice6/Invoice6Container";

const Invoice6 = () => {
  return <Invoice6Container />;
};

export default Invoice6;
